import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/arrow-left-s-line.png'


const _hoisted_1 = { class: "exchange-page" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "card-input" }
const _hoisted_4 = { class: "input-row" }
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = { class: "receiver-info" }
const _hoisted_7 = { class: "input-row" }
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = { class: "receiver-address" }
const _hoisted_10 = { class: "input-row" }
const _hoisted_11 = { class: "input-row" }
const _hoisted_12 = { class: "input-row" }
const _hoisted_13 = { class: "input-row" }
const _hoisted_14 = { class: "input-row-full" }
const _hoisted_15 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }, _cache[11] || (_cache[11] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "返回",
          class: "back-icon"
        }, null, -1)
      ])),
      _createElementVNode("h1", null, "兑换产品: " + _toDisplayString(_ctx.productName), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { for: "card-number" }, "礼品卡号: ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "card-number",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cardSerial) = $event)),
          type: "text",
          placeholder: "请输入礼品卡号"
        }, null, 512), [
          [_vModelText, _ctx.cardSerial]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[13] || (_cache[13] = _createElementVNode("label", { for: "card-password" }, "兑换码: ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "card-password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cardCode) = $event)),
          type: "text",
          placeholder: "请输入兑换码"
        }, null, 512), [
          [_vModelText, _ctx.cardCode]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[16] || (_cache[16] = _createElementVNode("h2", null, "收件人信息", -1)),
      _createElementVNode("div", _hoisted_7, [
        _cache[14] || (_cache[14] = _createElementVNode("label", { for: "receiver-name" }, "收件人: ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "receiver-name",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.receiverName) = $event)),
          type: "text",
          placeholder: "请输入收件人名称"
        }, null, 512), [
          [_vModelText, _ctx.receiverName]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[15] || (_cache[15] = _createElementVNode("label", { for: "receiver-phone" }, "手机号: ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "receiver-phone",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.receiverMobile) = $event)),
          type: "text",
          placeholder: "请输入手机号"
        }, null, 512), [
          [_vModelText, _ctx.receiverMobile]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[22] || (_cache[22] = _createElementVNode("h2", null, "收件人地址", -1)),
      _createElementVNode("div", _hoisted_10, [
        _cache[17] || (_cache[17] = _createElementVNode("label", { for: "province" }, "省: ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "province",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addrProvince) = $event)),
          type: "text",
          placeholder: "请输入省"
        }, null, 512), [
          [_vModelText, _ctx.addrProvince]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _cache[18] || (_cache[18] = _createElementVNode("label", { for: "city" }, "市: ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "city",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addrCity) = $event)),
          type: "text",
          placeholder: "请输入市"
        }, null, 512), [
          [_vModelText, _ctx.addrCity]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[19] || (_cache[19] = _createElementVNode("label", { for: "district" }, "区/县: ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "district",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.addrArea) = $event)),
          type: "text",
          placeholder: "请输入区/县"
        }, null, 512), [
          [_vModelText, _ctx.addrArea]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[20] || (_cache[20] = _createElementVNode("label", { for: "street" }, "街道/乡镇: ", -1)),
        _withDirectives(_createElementVNode("input", {
          id: "street",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.addrStreet) = $event)),
          type: "text",
          placeholder: "请输入街道、乡镇"
        }, null, 512), [
          [_vModelText, _ctx.addrStreet]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[21] || (_cache[21] = _createElementVNode("label", { for: "address-detail" }, "详细地址: ", -1)),
        _withDirectives(_createElementVNode("textarea", {
          id: "address-detail",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.addrDetail) = $event)),
          placeholder: "请输入详细地址",
          rows: "3"
        }, null, 512), [
          [_vModelText, _ctx.addrDetail]
        ])
      ])
    ]),
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "exchange-instructions" }, [
      _createElementVNode("h2", null, "兑换说明"),
      _createElementVNode("div", { class: "instructions-content" }, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, "请确保填写的礼品卡号和兑换码正确无误。"),
          _createElementVNode("li", null, "收件人信息必须真实有效，以便顺利接收商品。"),
          _createElementVNode("li", null, "地址信息需填写完整，确保商品能够准确送达。"),
          _createElementVNode("li", null, "兑换成功后，商品将在3-5个工作日内发货。"),
          _createElementVNode("li", null, "如有疑问，请联系客服：19941356990。")
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        class: "confirm-button",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleConfirm && _ctx.handleConfirm(...args)))
      }, "确认兑换")
    ])
  ]))
}